// src/com/bulk_products/BulkProductsDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// Bulk Products, bulk_products
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    bulkProductsId : {
		id: 'bulkProductsId', label: 'bulkProductsId',
		type: InputType.number, required: true, toAdd: false, toEdit: true,
		check: (value) => {return value >= 1 && value <= 99999999},
	}, // int(11)
    prodName : {
		id: 'prodName', label: 'Bulk 상품',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '50자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 50)},
	}, // varchar(50)
    /* useYn : {
		id: 'useYn', label: 'useYn',
		type: InputType.checkbox, required: true, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('Y','N')
    updatedDate : {
		id: 'updatedDate', label: 'updatedDate',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    updatedUser : {
		id: 'updatedUser', label: 'updatedUser',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	}, // varchar(40) */
    
};

/**
 * BULK_PRODUCTS React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2026-05-14 13:47:37 using DbdbTap
 * https://www.dbdbtap.com
 */
export const BulkProductsDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: 'Bulk 상품 등록 오류',
        Edit: 'Bulk 상품 수정 오류',
        Remove: 'Bulk 상품 삭제 오류',
        Get: 'Bulk 상품 조회 오류',
    },
    tableProps: {
        tableId: 'bulkProductsTable',
        uniqueKey: 'bulkProductsId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            // 주어진 bulkCompanyId에 해당되는 상품과 그렇지 않은 상품을 구분하여 출력.
            // 이를 위해 BULK_COMPANY_PRODUCTS 데이터를 참조하여 새로운 목록을 만들어야 함.
            //print using getTableColumnOption(c,t,i)
            // { id: 'bulkProductsId', label: Dict.bulkProductsId.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'prodName', label: Dict.prodName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'useYn', label: '사용여부', width: 80, show: true, option:{align: 'center', print:(r,i,v)=>v==='Y'?'사용':'사용중지'} },
            { id: 'comName', label: '업체사용', width: 160, show: true, option:{align: 'center', type:TableColumnType.TEXT} }, // 업체명 또는 '-'
            { id: 'updatedDate', label: '등록일', width: 160, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
};
